import { Modal as AntModal } from 'antd';

import styled from 'styled-components';

export const Modal = styled(AntModal)`
  .ant-modal-footer {
    border-top: none !important;
    padding: 0px !important;
  }

  .ant-modal-body {
    padding: 48px 0 24px 0 !important;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px 0;
  gap: 24px;
`;
